(ns frontend.ui.component.lp-portal.report.body.private-equity.pdf.view.tearsheet
  (:require
   [frontend.ui.component.chart.view :as chart-view]
   [frontend.ui.component.lp-portal.card.pdf.view :refer [card]]
   [frontend.ui.component.lp-portal.column.pdf.view :refer [columns]]
   [frontend.ui.component.lp-portal.page.pdf.view :as page]
   [frontend.ui.component.lp-portal.table.pdf.view :as table]
   [frontend.ui.component.lp-portal.text-content.pdf.view :as text-content]
   [potpuri.core :as potpuri]
   [frontend.ui.component.lp-portal.table.pdf.view :as pdf-table]))

(defn- tearsheet-page-left
  [{:keys [tvpi return-development]}]
  (card
   "Return development"
   {:stack [{:svg   (chart-view/chart-svg "highcharts"
                                          (potpuri/deep-merge
                                           (:figures tvpi)
                                           {:chart {:width  500
                                                    :height 350}}))
             :width 250}
            (text-content/optional-footer tvpi)
            {:text " "}
            (table/tearsheet-table {:rows (:figures return-development)})
            (text-content/optional-footer return-development)]}))

(defn- tearsheet-page-center
  [{:keys [largest-investments-at-fair-value
           portfolio-by-country-at-fair-value]}]
  [(card
    "Largest investment at fair value"
    {:svg   (chart-view/chart-svg "highcharts"
                                  (potpuri/deep-merge (:figures largest-investments-at-fair-value)
                                                      {:chart {:width  500
                                                               :height 350}}))
     :width 250}
    (text-content/optional-footer largest-investments-at-fair-value))
   (when portfolio-by-country-at-fair-value
     (card
      "Portfolio by country at fair value"
      {:svg   (chart-view/chart-svg "highcharts"
                                    (potpuri/deep-merge
                                     (:figures portfolio-by-country-at-fair-value)
                                     {:chart {:width  500
                                              :height 350}}))
       :width 250}
      (text-content/optional-footer portfolio-by-country-at-fair-value)))])

(defn- tearsheet-page-right
  [{:keys [basic-information-primary basic-information-secondary]}]
  (let [primary (:figures basic-information-primary)
        secondary (:figures basic-information-secondary)]
    (card
     "Basic Information"
     (pdf-table/dynamic-stack primary)
     (pdf-table/dynamic-stack secondary)
     (text-content/optional-footer basic-information-primary)
     (text-content/optional-footer basic-information-secondary))))

(defn tearsheet-page
  [report-data]
  (let [tearsheet-data (:tearsheet report-data)]
    (page/page
     (page/second-column-background)
     (page/page-title {:fund-name  (:fund-name report-data)
                       :page-title "Tear sheet"
                       :toc-item   true})
     (columns
      (tearsheet-page-left tearsheet-data)
      (tearsheet-page-center tearsheet-data)
      (tearsheet-page-right tearsheet-data)))))
